import { z } from 'zod';
import { get } from '../http';
import { type ListQuery, paginated, resource } from '../schemas/common';
import { binaryTreeNodeSchema, teamStatsSchema, userSchema } from '../schemas/domain';

export interface TeamListQuery extends ListQuery {
  level?: number;
  active_only?: boolean;
}

export const teamApi = {
  stats: () => get('/team/stats', resource(teamStatsSchema)),

  /** Unilevel: direct sponsors only. */
  direct: (query: TeamListQuery = {}) => get('/team/direct', paginated(userSchema), query),

  /** Unilevel: levels 1-7 of the sponsor tree. */
  level: (query: TeamListQuery = {}) => get('/team/level', paginated(userSchema), query),

  /** Flat referral list used by the income screens. */
  referralList: (query: TeamListQuery = {}) => get('/team/referral-list', paginated(userSchema), query),

  /** Binary placement tree — drives Achievement Rewards, not level income. */
  binaryTree: (rootUserId?: string, depth = 3) =>
    get('/team/binary-tree', resource(binaryTreeNodeSchema), { root: rootUserId, depth }),

  binaryLegCounts: () =>
    get(
      '/team/binary-legs',
      resource(
        z.object({
          left_total: z.number(),
          right_total: z.number(),
          left_active: z.number(),
          right_active: z.number(),
          matched: z.number(),
        }),
      ),
    ),

  /* admin */
  adminTree: (userId: string, depth = 3) =>
    get(`/admin/members/${userId}/binary-tree`, resource(binaryTreeNodeSchema), { depth }),
  adminDownline: (userId: string, query: TeamListQuery = {}) =>
    get(`/admin/members/${userId}/downline`, paginated(userSchema), query),
};
